import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { SmartDiaryEntry } from '../../type';

export const useSmartDiaryTotalDuration = (
  result: Record<string, boolean>,
  smartEntryMap: Record<string, SmartDiaryEntry>
): number => {
  return useMemo(() => {
    const checkedNotes = Object.keys(result).filter((key) => result[key]);
    const totalDuration = checkedNotes.reduce((acc, id) => {
      if (smartEntryMap[id]?.startTime && smartEntryMap[id]?.endTime) {
        const start = DateTime.fromISO(smartEntryMap[id]?.startTime ?? '');
        const end = DateTime.fromISO(smartEntryMap[id]?.endTime ?? '');
        const diff = end.diff(start);
        const duration = diff.shiftTo('seconds').toObject()?.seconds;
        return (acc += duration ?? 0);
      } else {
        return (acc += smartEntryMap[id]?.duration?.value ?? 0);
      }
    }, 0);
    return totalDuration;
  }, [result, smartEntryMap]);
};
